module.exports = __webpack_public_path__ + "img/jupiter.f3136b41.svg";